
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/media/album",
      function () {
        return require("private-next-pages/media/album.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/media/album"])
      });
    }
  